import axios from 'axios';
class VendorService {
    axiosInstances;
    static auth;
    static config;
    static vendors = [];
    constructor(auth, axiosInstances, config) {
        this.axiosInstances = axiosInstances;
        VendorService.auth = auth;
        VendorService.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${VendorService.auth.currentToken}`,
        };
    }
    adminPortal = {
        activity: {
            query: async (query) => {
                const { data } = await this.axiosInstances.mainInstance.get('/hauler/admin-portal/activity', {
                    params: query,
                });
                return data;
            },
        },
        query: async (query) => {
            const { data } = await this.axiosInstances.mainInstance.get('/hauler/admin-portal', {
                params: query,
            });
            VendorService.vendors = data;
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axiosInstances.mainInstance.get(`/hauler/admin-portal/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axiosInstances.mainInstance.post('/hauler/admin-portal', input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axiosInstances.mainInstance.put(`/hauler/admin-portal/${id}`, input);
            return data;
        },
        contacts: {
            create: async (input) => {
                const { data } = await this.axiosInstances.mainInstance.post('/hauler/admin-portal/sap-contact', input);
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/admin-portal/sap-contact/${id}`, input);
                return data;
            },
            delete: async (id) => {
                const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/admin-portal/sap-contact/${id}`);
                return data;
            },
        },
    };
    wayste = {
        partnerPortal: {
            contacts: {
                create: async (input) => {
                    const { data } = await this.axiosInstances.mainInstance.post('/hauler/wayste/partner-data/contact', input);
                    return data;
                },
                update: async (id, input) => {
                    const { data } = await this.axiosInstances.mainInstance.patch(`/hauler/wayste/partner-data/contact/${id}`, input);
                    return data;
                },
                delete: async (id) => {
                    const { data } = await this.axiosInstances.mainInstance.delete(`/hauler/wayste/partner-data/contact/${id}`);
                    return data;
                },
            },
            files: {
                update: async (input) => {
                    const { data } = await this.axiosInstances.mainInstance.patch('/hauler/wayste/partner-data/add-files', input);
                    return data;
                },
            },
        },
    };
    appAdmin = {
        create: async (input) => {
            const { data } = await this.axiosInstances.appAdminInstance.post('/hauler/admin-portal', input);
            return data;
        },
    };
    /**
     * @deprecated Use `adminPortal.query` instead.
     */
    async fetch() {
        const response = await axios({
            method: 'GET',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal`,
            headers: this.headers(),
        });
        VendorService.vendors = response.data;
        return response;
    }
    /**
     * @deprecated Use `adminPortal.fetchById` instead.
     */
    async fetchById(id) {
        const response = await axios({
            method: 'GET',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal/${id}`,
            headers: this.headers(),
        });
        return response;
    }
    /**
     * @deprecated Use `adminPortal.create` instead.
     */
    async create(data) {
        const response = await axios({
            method: 'POST',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal`,
            headers: this.headers(),
            data: data,
        });
        return response.data;
    }
    /**
     * @deprecated Use `adminPortal.update` instead.
     */
    async update(id, data) {
        const response = await axios({
            method: 'PUT',
            url: `${VendorService.config.API.baseApiUrl}/hauler/admin-portal/${id}`,
            headers: this.headers(),
            data: data,
        });
        return response;
    }
}
export default VendorService;
//# sourceMappingURL=Vendor.service.js.map